import PremiumPlayerSide from './PremiumPlayerSide';

export default PremiumPlayerSide;
